import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const BreadcrumbNavigation = ({ className = '' }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const routeMap = {
    '/admin-dashboard': { label: 'Dashboard', icon: 'LayoutDashboard' },
    '/staff-management': { label: 'Staff Management', icon: 'Users' },
    '/booking-management': { label: 'Booking Management', icon: 'ChartLine' },
    '/service-management': { label: 'Service Management', icon: 'Wrench' },
    '/category-management': { label: 'Category Management', icon: 'FolderCog' },
    '/business-profile-settings': { label: 'Business Settings', icon: 'Settings' },
    '/reporting': { label: 'Reporting', icon: 'Landmark' },
    '/user-profile': { label: 'User Profile', icon: 'User' },
  };

  const generateBreadcrumbs = () => {
    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [];

    // Always include Dashboard as home
    if (location?.pathname !== '/admin-dashboard') {
      breadcrumbs?.push({
        label: 'Dashboard',
        path: '/admin-dashboard',
        icon: 'LayoutDashboard',
        isClickable: true
      });
    }

    // Add current page
    const currentRoute = routeMap?.[location?.pathname];
    if (currentRoute) {
      breadcrumbs?.push({
        label: currentRoute?.label,
        path: location?.pathname,
        icon: currentRoute?.icon,
        isClickable: false,
        isCurrent: true
      });
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  // Don't render breadcrumbs if we're on the dashboard or login page
  if (location?.pathname === '/admin-dashboard' || location?.pathname === '/login') {
    return null;
  }

  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <nav className={`flex items-center space-x-2 text-sm ${className}`} aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {breadcrumbs?.map((crumb, index) => (
          <li key={crumb?.path} className="flex items-center">
            {index > 0 && (
              <Icon 
                name="ChevronRight" 
                size={16} 
                className="text-muted-foreground mx-2" 
              />
            )}
            
            <div className="flex items-center space-x-2">
              {crumb?.isClickable ? (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => handleNavigation(crumb?.path)}
                  className="h-auto p-1 text-muted-foreground hover:text-foreground transition-smooth"
                >
                  <Icon name={crumb?.icon} size={16} className="mr-1" />
                  {crumb?.label}
                </Button>
              ) : (
                <div className="flex items-center space-x-1 px-1">
                  <Icon 
                    name={crumb?.icon} 
                    size={16} 
                    className={crumb?.isCurrent ? 'text-primary' : 'text-muted-foreground'} 
                  />
                  <span 
                    className={`font-medium ${
                      crumb?.isCurrent 
                        ? 'text-foreground' 
                        : 'text-muted-foreground'
                    }`}
                  >
                    {crumb?.label}
                  </span>
                </div>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default BreadcrumbNavigation;